import { useQuery } from "@tanstack/react-query";
import { fetchOrders } from "../services/orderService";

export const useOrders = (page = 1, search = "", status = "") => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["orders", page, search, status],
    queryFn: () => fetchOrders(page, search, status),
    select: (response) => {
      return {
        orders: response.message?.orders?.data || [],
        orderStats: response.message || {},
        pagination: {
          current_page: response.message?.orders?.current_page,
          total: response.message?.orders?.total,
          per_page: response.message?.orders?.per_page,
          last_page: response.message?.orders?.last_page,
        },
      };
    },
  });

  return {
    orders: data?.orders || [],
    loading: isLoading,
    error: error?.message || null,
    orderStats: data?.orderStats || {},
    pagination: data?.pagination || null,
  };
};
